const Header = () => (
  <header className="App-header max-w-5xl w-full py-4 px-4 lg:px-8 border-b border-slate-900/10 font-bold">
    <h1 className="text-2xl sm:text-center uppercase">💵 Salario justo</h1>
  </header>
);

export default Header;
